export enum AccessStatus {
  None,
  Pending,
  Granted,
}
